import {createRouter, createWebHashHistory, createWebHistory} from 'vue-router';
import NProgress from 'nprogress';
import {log} from '@/utils/logger';
import StatsTestPage from '@/pages/stats/StatsTestPage.vue';

/** Declare only when needed. */
export const ROUTES = {
	STATS_PLAYER: 'stats-player',
	STATS_TEAM: 'stats-team',
	STATS_GAME: 'stats-game',
	STATS_SEASON: 'stats-season',
};

export const ROUTING_MODE = import.meta.env.PROD ? 'history' : 'hash';

const TITLE_TEMPLATE = '%s | hockeyfans.ch';
const DEFAULT_TITLE = 'Hockeyfans';

const indexRouter = createRouter({
	history: ROUTING_MODE === 'history' ? createWebHistory(import.meta.env.BASE_URL) : createWebHashHistory(),
	routes: [
		{
			path: '/',
			redirect: '/stats'
		},
		{
			path: '/stats',
			component: () => import('@/pages/stats/StatsPortalPage.vue'),
		},
		{
			path: '/stats/test',
			component: StatsTestPage,
			meta: {title: 'Statistiken'},
		},
		{
			name: 'stats-portal-leagueId',
			path: '/stats/portal/:leagueId?',
			component: () => import('@/pages/stats/StatsPortalPage.vue'),
			props: true,
		},
		{
			path: '/stats/spieler',
			component: () => import('@/pages/stats/PlayerStatsPage.vue'),
		},
		{
			path: '/stats/goalie',
			component: () => import('@/pages/stats/GoalieStatsPage.vue'),
		},
		{
			path: '/stats/leader',
			component: () => import('@/pages/stats/LeaderStatsPage.vue'),
		},
		{
			name: ROUTES.STATS_TEAM,
			path: '/stats/team/:preselectedStatsQuery?',
			component: () => import('@/pages/stats/TeamStatsPage.vue'),
			props: true
		},
		{
			name: ROUTES.STATS_GAME,
			path: '/stats/game/:preselectedTeamId?',
			component: () => import('@/pages/stats/GameStatsPage.vue'),
			props: true
		},
		{
			name: ROUTES.STATS_SEASON,
			path: '/stats/saison/:preselectedTeamId?',
			component: () => import('@/pages/stats/SeasonOverviewPage.vue'),
			props: true,
			meta: {title: 'Spiel für Spiel', wide: true},
		},
		{
			name: ROUTES.STATS_PLAYER,
			path: '/spieler/stats/:playerId',
			component: () => import('@/pages/stats/PlayerPage.vue'),
			props: true
		},
		{
			path: '/404',
			component: () => import('@/pages/ErrorPage.vue'),
		},
		{
			path: '/503',
			component: () => import('@/pages/ServiceUnavailablePage.vue'),
		},
		{
			path: '/:pathMatch(.*)*',
			component: () => import('@/pages/ErrorPage.vue'),
		},
	],
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		} else if (to.hash) {
			return {el: to.hash};
		} else {
			return {top: 0, left: 0};
		}
	},
});

indexRouter.beforeEach((to, from) => {
	NProgress.start();
	log.debug(`Routing to ${to.fullPath} [${from.fullPath}]`, to.name);
});

indexRouter.afterEach((to) => {
	const title = typeof to.meta.title === 'string' ? to.meta.title : DEFAULT_TITLE;
	document.title = TITLE_TEMPLATE.replace('%s', title);
	log.debug(`Finished routing to ${to.fullPath}`);
	NProgress.done();
});

export default indexRouter;
